import { createAuthContext } from '@react-keycloak-fork/core';
export var reactKeycloakWebContext = createAuthContext();
export var ReactKeycloakWebContextConsumer = reactKeycloakWebContext.Consumer;
